import { defineComponent as _defineComponent } from 'vue'
import { sanitizeTitle } from 'bits/landside_helper'
import ImageThumbnail from 'library/v4/components/ImageThumbnail.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePageWallFormatCard',
  props: {
    title: null,
    width: null,
    imageUrl: null,
    originalImageWidth: null,
    originalImageHeight: null,
    shouldFlipImage: { type: Boolean, default: false },
    lazyLoading: { type: Boolean, default: true }
  },
  setup(__props: any) {



return { __sfc: true,sanitizeTitle, ImageThumbnail }
}

})